// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__JGxhP","slideIn":"Notification_slideIn__szX17","content":"Notification_content__ocifm","closeButton":"Notification_closeButton__bBKpj"};